<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head">
            <h1>접근 권한 안내</h1>
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              <p>
                [간판ON]<br />
                서비스 이용을 위해 다음 권한들을 사용합니다.
              </p>
            </div>
            <div class="infobox">
              <p>
                <span class="title"><i class="ico-position"></i>위치 [선택]<br /></span>
                <span class="text">현재 위치 확인 및 지도 서비스 사용</span>
              </p>
              <br />
              <p>
                <span class="title"><i class="ico-call"></i>연락처 [선택]<br /></span>
                <span class="text">친구 초대, 연락처 저장, 전화 걸기</span>
              </p>
              <br />
              <p>
                <span class="title"><i class="ico-camera"></i>카메라 [선택]<br /></span>
                <span class="text">게시글작성 및 프로필 설정</span>
              </p>
              <br />
              <p>
                <span class="title"><i class="ico-photo"></i>사진(앨범) [선택]<br /></span>
                <span class="text">게시글작성 및 프로필 설정</span>
              </p>
              <br />
              <p>
                <span class="title"><i class="ico-floppy"></i>저장공간 [선택]<br /></span>
                <span class="text">기기 내 저장된 파일/기기 외부 저장소 사용</span>
              </p>
            </div>
          </div>
          <BasicButton modal-btn single-text="확인" @click="close" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import BasicButton from '@/components/common/layouts/BasicButton.vue';
import { computed } from 'vue';
import store from '@/store';
import router from '@/router';
import { isEmpty } from '@/common/utils/Util';
const props = defineProps(['data']);
const { fnCallBack } = props.data;
const emits = defineEmits(['close']);

const loginPath = computed(() => store.getters['layout/getLoginMovePath']);
const close = () => {
  if (!isEmpty(loginPath.value)) {
    store.commit('user/setFirstLogin', true);
    router.replace('/signin');
    emits('close');
  } else if (fnCallBack) fnCallBack();
};
</script>

<style scoped></style>
